<app-form-checkbox-with-description
  [fg]="fg()"
  [(checked)]="ignoreIfAutonomousWithTriggers"
  [titleLabelKey]="getTitleLabelKey()"
  [descriptionLabelKey]="getDescriptionLabelKey()"
></app-form-checkbox-with-description>
